export const REPLACE_AND_DEPRECATE = 'replaceAndDeprecate';
export const REPLACE_AND_DELETE = 'replaceAndDelete';
